export default __webpack_public_path__ + "static/media/manat_icon.f3a0f26e.png";